
import { styled, Tabs } from '@mui/material';

const PageTabs = styled(Tabs)(({ theme }) => ({
    color: '#333333',
    '& .MuiTabs-indicator': {
        color: '#001A69',
        backgroundColor: '#001A69',
        height: '3px',
        borderRadius: '4px',
    }
}));

export default PageTabs;